export default __webpack_public_path__ + "static/media/img15.9cd763f9.jfif";